module.exports = __webpack_public_path__ + "static/img/05942686.d1d34ff8.png";